/* eslint-disable camelcase */
/**
 * 防重复执行,限制高频触发
 * @param fn 应执行的函数
 * @param wait 距离最后一次触发的时间
 * @param outset 触发模式
 *    true => 开始时间点执行
 *    false => 结束时间点执行
 *    'fixed' => 固定间隔wait时间段后，能触发一次
 *  @param 'forwards' => 'fixed'模式结束时间点是否响应
 */

// 清除表情
export function regEmoji (text) { // 清除表情
    let regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
    return text.replace(regStr, '');
}

export function $debounce (fn, wait, outset = false, forwards = false) {
    let context = null;
    let lastCall = null;
    let argu = null;
    let timeOut = null;
    let isFix = outset === 'fixed';

    /* 延迟检测函数，检测距离最后一次触发的时间间隔 */
    function timeUp () {
        let interval = new Date() - lastCall; // 最后一次触发的时间间隔;
        if (interval < wait) {
            timeOut = setTimeout(timeUp, isFix && wait || wait - interval);
            /* fixed模式的固定时间点执行 */
            isFix && fn.apply(context, argu);
        } else {
            timeOut = null;
            if (!outset || (isFix && forwards)) { // 结束时间点执行和fixed模式的最后一次触发时间点执行
                fn.apply(context, argu);
            }
            argu = context = null;
        }
    }

    /* 返回闭包函数 */
    return function (...rest) {
        context = this;
        argu = rest;
        /* 记录最后触发时间 */
        if (!isFix || forwards || !lastCall) {
            lastCall = new Date();
        }
        if (outset && !timeOut) { // 开始时间点执行和fixed模式的固定时间点执行
            fn.apply(context, argu);
        }
        if (!timeOut) timeOut = setTimeout(timeUp, wait); // 首次触发产生延迟函数
    };
}

/**
 * JSON.parse的排错处理
 * @param param
 * @returns {*}
 * @constructor
 */
export function JsonParse (param) {
    if (typeof param === 'string' && (/^\{.*\}$|^\[.*\]$/).test(param)) {
        return JSON.parse(param);
    }
    return param;
}

/**
 * 查找最近的父级元素
 * @param param
 * @returns {*}
 * @constructor
 */
export function $closest (el, selector) {
    let name = el.localName;
    if (name === selector) {
        return el;
    } else if (name !== 'html') {
        return $closest(el.parentNode, selector);
    }
    return null;
}

/**
 * 查找子类元素
 * @param param
 * @returns {*}
 * @constructor
 */
export function $find (el, cls) {
    if (!el) return [];
    let res = [];
    if (el.length) {
        Array.from(el).forEach(e => {
            res.push(...$find(e, cls));
        });
    } else {
        if (Array.from(el.classList).includes(cls)) {
            res.push(el);
        }
        if (el.children && el.children.length) {
            res.push(...$find(el.children, cls));
        }
    }
    return res;
}

/**
 *深拷贝
 * @peram deep
 *   true => 深拷贝,
 *   vue => 适用于VUE的深拷贝(删除原对象多余的数组),
 *   'add' => 只增加新属性的深拷贝,
 *   'reader' => 只改变已有属性的深拷贝
 *   'reader-arr' => 只改变已有属性的深拷贝, 可添加数组
 * ps: 被拷贝属性为 undefined时跳过
 * @return 目标对象
 */
export function $extend (deep, ...rest) {
    if (deep !== true && typeof deep === 'object') { // simple copy
        return Object.assign(deep, ...rest);
    } else if (rest.every(v => typeof v === 'object')) { // deep copy
        let [own, ...copy] = rest;
        deep === 'add' && copy.reverse();
        copy.forEach(obj => {
            // console.log(obj);
            let isArray = Object.prototype.toString.call(obj) === '[object Array]' && !!own.splice;
            if (deep === 'vue' && isArray && obj.length < 1) own.splice(0, own.length);
            for (let key in obj) {
                if (!obj.hasOwnProperty(key)) continue;// ignore prototype
                let own_val = own[key]; let copy_val = obj[key];
                let hasProperty = (deep === 'reader-arr' && !!own.splice) || own.hasOwnProperty(key);
                let isLimit = !(deep === 'add' && hasProperty) && !((deep === 'reader' || deep === 'reader-arr') && !hasProperty);

                if (typeof copy_val === 'object' && copy_val !== null) { // Copy the arrays, objects
                    let constCopy = copy_val.constructor;
                    let constOwn = (own_val !== undefined && own_val !== null) && own_val.constructor;
                    if (constOwn === constCopy) {
                        $extend(deep, own_val, copy_val);
                        if (isArray) {
                            if (deep === 'vue' && key * 1 === obj.length - 1) {
                                own.splice(obj.length);
                            }
                        }
                    } else if (isLimit) { // own_val === undefined or null
                        if (isArray) {
                            own.splice(key, 1, $extend((deep === 'reader' || deep === 'reader-arr') && true || deep, constCopy === Array ? [] : {}, copy_val));
                            if (deep === 'vue' && key * 1 === obj.length - 1) {
                                own.splice(obj.length);
                                break;
                            }
                        } else {
                            $extend((deep === 'reader' || deep === 'reader-arr') && true || deep, own[key] = constCopy === Array ? [] : {}, copy_val);
                        }
                    }
                } else if (isLimit && copy_val !== undefined) {
                    if (isArray) {
                        own.splice(key, 1, copy_val);
                        if (deep === 'vue' && key * 1 === obj.length - 1) {
                            own.splice(obj.length);
                        }
                    } else {
                        own[key] = copy_val;
                    }
                }
            }
        });
        return own;
    }
}

/**
 * 日期格式化
 * @param d
 * @returns {*}
 */
export function dataFormat (d) {
    let year = d.getFullYear();
    let month = d.getMonth() + 1 + '';
    let date = d.getDate() + '';
    month = month.length < 2 && '0' + month || month;
    date = date.length < 2 && '0' + date || date;
    return year + '-' + month + '-' + date;
    // return d.toLocaleDateString().replace(/\/|年|月/g, '-').replace('日', '')
}

/**
 * 随机生成id
 * @param n 默认32位
 * @returns {string}
 */
export function $randomId (n = 32) {
    let s = '';
    Array.from({ length: n }).forEach((v, i) => {
        let r = Math.floor(Math.random() * 36);
        if (r < 10) {
            s += r;
        } else {
            s += String.fromCharCode(r + 87);
        }
        if ([7, 11, 15, 19].includes(i)) s += '-';
    });
    return s;
}

/**
 * 并发请求数量限制
 * @param arr 包含发起请求的promise对象的数组
 * @param count 同时请求的数量
 * @returns {Function} 传入false时中断后续请求
 */
export function $concurrent (arr = [], count = 4, param) {
    /* 并发发起四个请求，其中任一请求结束后，发起新的请求，保持并发请求数量不超过四个 */
    return new Promise((resolve, reject) => {
        let g = generator();
        let keep = true;
        let result = [];
        for (let i = 0; i < count; i++) {
            nextCall();
        }

        function nextCall () {
            let { value, done } = g.next();
            done || Promise.resolve(value).then((data) => {
                if (data === 'reject') {
                    resolve(result);
                    return;
                }
                result.push(data);
                if (result.length === arr.length) {
                    keep = false;
                    resolve(result);
                }
                keep && nextCall();
            }).catch(() => {
                keep = false;
                reject(new Error());
            });
        }

        function * generator () {
            if (arr.length === 0) {
                yield Promise.resolve('reject');
            }
            for (let fn of arr) {
                try {
                    yield fn(param);
                } catch (e) {
                    return e;
                }
            }
        }
    });
    // return function (p) {
    //   keep = p;
    // }
}

/**
 * 根据权限配置路由和菜单
 * @param arr 所有的路由和菜单
 * @param codes 模块权限代码 actionCodes
 * @param orgId 身份id
 * @param orgType 身份type
 * @param identityId 身份type
 * @param type 配置路由或菜单
 * @param prevPath 仅作用与type === router
 * @returns {Array}
 */
export function configAccess (arr = [], codes, { orgId, orgType, identityId }, type = 'router', prevPath = '/') {
    let res = [];
    arr.forEach(itm => {
        let temp = Object.assign({}, itm),
            access = temp.meta && temp.meta.access || temp.access;
        if (type === 'router') {
            temp.fullPath = itm.path && itm.path.startsWith('/') && itm.path || prevPath + itm.path;
        }
        if (temp.children && temp.children.length > 0) {
            temp.children = configAccess(temp.children, codes, { orgId, orgType, identityId }, type, temp.fullPath + '/');
            if (!temp.redirect && type === 'router') {
                let redirect = temp.children && temp.children.length && temp.children[0].fullPath;
                if (redirect) {
                    temp.redirect = redirect;
                }
            }
        }
        if (access) {
            let {
                    actionsCode = [],
                    customCode = [],
                    exCustomCode = [],
                    orgIdRoles = [],
                    exOrgIdRoles = [],
                    orgTypeRoles = [],
                    exOrgTypeRoles = [],
                    identityIdRoles = [],
                    exIdentityIdRoles = [],
                } = access,
                /* code能匹配或者不需要权限 */
                action = actionsCode.length ? actionsCode.some(code => codes.includes(code)) : true,
                /* 自定义权限code能匹配或者不需要权限 */
                custom = customCode.length ? customCode.some(code => codes.includes(code)) : true,
                /* 需要隐藏的自定义权限code或者不需要权限 */
                exCustom = exCustomCode.length ? exCustomCode.some(code => codes.includes(code)) : false,
                /* orgId能匹配或者不需要权限 */
                org = orgIdRoles.length ? inArray(orgIdRoles, orgId) : true,
                /* 需要隐藏的orgId或者不需要权限 */
                out = exOrgIdRoles.length ? inArray(exOrgIdRoles, orgId) : false,
                /* orgType能匹配或者不需要权限 */
                orgTy = orgTypeRoles.length ? inArray(orgTypeRoles, orgType) : true,
                /* 需要隐藏的orgType或者不需要权限 */
                OutTy = exOrgTypeRoles.length ? inArray(exOrgTypeRoles, orgType) : false,
                /* identityId能匹配或者不需要权限 */
                inIdent = identityIdRoles.length ? inArray(identityIdRoles, identityId) : true,
                /* 需要隐藏的identityId或者不需要权限 */
                outIdent = exIdentityIdRoles.length ? inArray(exIdentityIdRoles, identityId) : false;
            if (action && custom && !exCustom && org && !out && orgTy && !OutTy && inIdent && !outIdent) {
                res.push(temp);
            }
        } else {
            res.push(temp);
        }
    });
    return res;
}

function inArray (arr, p) {
    return arr.some(v => v + '' === p + '');
}

export function $passwordStrength (modifyWord) {
    if (modifyWord.length === 0) {
        return 'empty';
    }
    if (modifyWord.length < 6) {
        return 'weak';
    }
    let arr = modifyWord.split('');
    let val = arr[0];
    if (arr.every(item => item === val)) {
        return 'weak';
    }
    let strengthLevel = 0;
    if (/\d/.test(modifyWord)) strengthLevel++; // 数字
    if (/[a-zA-Z]/.test(modifyWord)) strengthLevel++; // 小写 大写
    if (/\W|_/.test(modifyWord)) strengthLevel++; // 特殊字符
    return strengthLevel === 1 ? 'medium' : 'strong';
}

export function highLightTableMsg (msg, highLightStr) {
    if (msg == null) {
        msg = '';
    }
    if (highLightStr == null) {
        highLightStr = '';
    }
    if (msg instanceof Object) {
        msg = JSON.stringify(msg);
    }
    if (highLightStr instanceof Object) {
        highLightStr = JSON.stringify(highLightStr);
    }
    if (!(msg instanceof String)) {
        msg = msg.toString();
    }
    if (!(highLightStr instanceof String)) {
        highLightStr = highLightStr.toString();
    }
    var htmlStr = '';
    if (highLightStr.length > 0) {
        if (msg.indexOf(highLightStr) !== -1) {
            assemblyStr(msg, highLightStr);
        } else {
            htmlStr = msg;
        }
    } else {
        htmlStr = msg;
    }
    function assemblyStr (msgAssembly, highLightAssembly) {
        if (msgAssembly.indexOf(highLightAssembly) !== -1) {
            var length = highLightAssembly.length;
            var start = msgAssembly.indexOf(highLightAssembly);
            htmlStr = htmlStr + msgAssembly.substring(0, start) + '<span class="log-hight-light">' + highLightAssembly + '</span>';
            msgAssembly = msgAssembly.substring(start + length, msgAssembly.length);
            assemblyStr(msgAssembly, highLightAssembly);
        } else {
            htmlStr = `${htmlStr}<span> ${msgAssembly} </span>`;
        }
    }
    return htmlStr;
}
